export const live = {
    zbz: "В эфире",
    ljks: "Начать сейчас",
    hmyzb: "Вы ещё не начинали трансляцию~",
    zbyg: "Анонс трансляции",
    yjs: "Завершено",
    jszb: "Завершить трансляцию",
    gbzb: "Закрыть трансляцию",
    jxzb: "Продолжить трансляцию",
    bctp: "Сохранить изображение",
    fxlj: "Поделиться ссылкой",
    zbydk: "Соединение с трансляцией разорвано, пожалуйста, подождите...",
    fh: "Назад",
    wjcdypsb: "Аудиоустройство не обнаружено",
    czsb: "Ошибка операции Canvas:",
    tpjzsb: "Не удалось загрузить изображение. Проверьте правильность URL и доступность изображения.",
    zbjl: "История трансляций",
    sqjl: "История заявок",
    lts: "Чат",
    ren: "чел.",
    gdcy: "Другие участники",
    cy: "Участники",
    jcjy: "Снять блокировку чата",
    jy: "Заблокировать в чате",
    qbjy: "Заблокировать всех",
    zbjs: "Описание трансляции",
    srnr: "Введите текст",
    tczbj: "Вас удалили из комнаты трансляции",
    qd: "Подтвердить",
    zbjjjs: "Ваша трансляция автоматически завершится через 10 минут!",
    zbsc: "Длительность трансляции:",
    ljgkrs: "Всего зрителей:",
    dzs: "Количество лайков:",
    zbjies: "Трансляция завершена",
    ybjy: "Ваш чат заблокирован",
    jycg: "Блокировка снята",
    jinycg: "Чат заблокирован",
    qbjinycg: "Все заблокированы",
    qbjycg: "Блокировка снята со всех",
    cwzb: "Стать ведущим",
    lxgzry: "Свяжитесь с сотрудником, чтобы стать ведущим",
    lxfs: "Контакты",
    zb: "Трансляция",
    xkt: "Мини-урок Biking",
    sqzb: "Запросить трансляцию",
    bczbzt: "Тема трансляции",
    srzt: "Введите тему",
    bczbjj: "Краткое описание трансляции",
    kbsj: "Время начала",
    xzrisj: "Выберите дату и время",
    tishi: "Подсказка",
    dksdzb: "На это время уже запланирована 1 трансляция",
    cxsj: "Продолжительность",
    xzsc: "Выберите длительность",
    fmt: "Обложка",
    fmtbnwk: "Обложка обязательна",
    sc: "Загрузить",
    yssc: "Максимум 10 МБ, пожалуйста, сожмите файл перед загрузкой",
    sccct: "Пожалуйста, загрузите изображение размером 360×170",
    tjsq: "Отправить заявку",
    tpcj: "Кадрирование изображения",
    tzcjwz: "Отрегулируйте область кадрирования, выберите сохраняемую область",
    scdtp: "Загруженное изображение",
    yl: "Предпросмотр (360×170)",
    cjtp: "Кадрировать",
    quxiao: "Отмена",
    qsrzbjj: "Введите краткое описание трансляции",
    qxzrq: "Пожалуйста, выберите дату",
    qxzsc: "Пожалуйста, выберите длительность",
    kssjdydqsj: "Время начала должно быть позже текущего момента",
    sctxtpdx: "Размер загружаемого аватара не должен превышать 10 МБ!",
    tjcg: "Отправлено успешно",
    jkshnr: "Мы рассмотрим вашу заявку в ближайшее время",
    hmysqgzb: "Вы ещё не подавали заявку на трансляцию~",
    shz: "На рассмотрении",
    tongg: "Одобрено",
    jujue: "Отклонено",
    yugao: "Запланировано",
    huifang: "Запись",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/live/ru.js